import React, { useState, useEffect } from "react";
import './Style/common.css';
import './Style/header.css';
import "./Style/MyCompsCurrent.css";
import './Style/trophy_club.css';
// import trophy_club_0 from './Image/trophy_club/trophy_club_0.png';
import Header from "../../Common/Header";
import Section from "../../Common/Section";

// interface Competition {
//   CompID: number;
//   CompTitle: string;
//   TermsAndConditions: string;
//   CompImageLink: string;
//   Points: number;
// }

const MyCompsCurrent: React.FC = () => {
  // const [competitions, setCompetitions] = useState<Competition[]>([]); 
  const [
    // myPoints
    , setMyPoints] = useState(0);
  const [
    // overallWeeklyProgress
    , setOverallWeeklyProgress] = useState(0);
  const [
    // weekCount
    , setWeekCount] = useState(0);
  const [
    // trophyData
    , setTrophyData] = useState<string[]>([]);
  const [
    // userName
    , setUserName] = useState<string>("");
  // const [purchases, setPurchases] = useState<any[]>([6405]);
  const [
    // imageSrc
    , setImageSrc] = useState('');

  //     useEffect(() => {
  //       const UserName = sessionStorage.getItem('FName');
  //       // const UserLogin = sessionStorage.getItem('login');
  //       const UserAvatar = sessionStorage.getItem('CurrentAvatar');

  //       if (UserName) setUserName(UserName);

  //       try {
  //         if (UserAvatar) setImageSrc(UserAvatar);
  //       } catch (error) {
  //         console.error('Error loading image:', error);
  //       }
  //       setMyPoints(1200);
  //       setOverallWeeklyProgress(75);
  //       setWeekCount(10);
  //       setTrophyData(["Gold", "Silver", "Bronze"]);
      
  //       document.body.classList.add('StudyRoom-background');
      
  //       return () => {
  //         document.body.classList.remove('StudyRoom-background');
  //       };
  //     }, []);
  //    useEffect(() => {
  //   const enforceScroll = () => {
  //     document.body.style.overflowY = 'auto';
  //     document.documentElement.style.overflowY = 'auto';
  //     document.body.style.height = 'auto';
  //     document.documentElement.style.height = 'auto';
  //   };
  //   enforceScroll(); // run immediately
  //   const observer = new MutationObserver(enforceScroll); // reapply on DOM changes
  //   observer.observe(document.body, { attributes: true, childList: false, subtree: false });
  
  //   return () => observer.disconnect();
  // }, []);

  useEffect(() => {
  const UserName = sessionStorage.getItem('FName');
  const UserAvatar = sessionStorage.getItem('CurrentAvatar');

  if (UserName) setUserName(UserName);

  try {
    if (UserAvatar) setImageSrc(UserAvatar);
  } catch (error) {
    console.error('Error loading image:', error);
  }

  setMyPoints(1200);
  setOverallWeeklyProgress(75);
  setWeekCount(10);
  setTrophyData(["Gold", "Silver", "Bronze"]);

  document.body.classList.add('StudyRoom-background');

  return () => {
    document.body.classList.remove('StudyRoom-background');
  };
}, []);

    // const handleTrophyClick = () => {
    //   const trophyClubLegend = document.getElementById("trophy_club_legend");
    //   if (trophyClubLegend) {
    //     trophyClubLegend.style.display = 
    //       trophyClubLegend.style.display === "none" ? "block" : "none";
    //   }
    // };

  return (
    <form>
      {/* <a href="/STUDENT/MSR/MyCompsCurrent" className="back-to-top">Back to Top</a>
      <a href="/STUDENT/MSR/MyCompsCurrent" className="back-to-bottom" id="back_to_bottom_link">Back to Top</a> */}
      <div
        // href="#"
        className="back-to-bottom"
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: "smooth"
          });
        }}
      >
        Back to Bottom
      </div>
        <div id="main_top_container">
            <Header />
            <Section />
            <div id="mi_banner" className="subject_banner">
                <div id="mi_banner_text_img"></div>
            </div>
            <div id="mi_page_btn_container">
                <div id="mi_page_btn_store" className="mi_page_btn">
                    <a id="hlinkStore" href="/STUDENT/MSR/MyStore" >Store</a></div>
                            <div id="mi_page_btn_avatars" className="mi_page_btn">
                    <a id="hlinkMyIncentives" href="/STUDENT/MSR/MyIncentives" >Avatars</a></div>
                <div id="mi_page_btn_comp" className="mi_page_btn mi_page_btn_selected">
                    <a href="/STUDENT/MSR/MyCompsCurrent">Comps</a></div>            
                <div id="mi_page_btn_purchase" className="mi_page_btn mi_page_btn_last">
                    <a id="hlinkPurchases" href="/STUDENT/MSR/AllPurchases" >Purchases</a></div>
            </div>
            <div id="mi_page_comps_current" className="contents section_container mi_page_bg">
                <div id="mi_comps_current_container" className="section_div">
                    <div id="mi_comps_toggle_row">
                        <div id="mi_comps_toggle_container">
                        <div className="mi_comps_toggle_button" id="mi_comps_toggle_buttonT"
                        >
                                <a href="/STUDENT/MSR/MyCompsCurrent" >Current Comps</a>
                            </div>
                        <div className="mi_comps_toggle_button mi_comps_toggle_button_clear">
                                <a id="hlinkPastComps" href="/STUDENT/MSR/MyCompsPast" >Past Comps</a>
                              </div>
                        </div>
                    </div>
                    <div className="subject_middle_gap"></div>
                    <div className="subject_bottom_gap"></div>
                </div>
            </div>
            {/* <div id="divSubjectBanner" className="subject_banner">
                <div className="subject_arrow_left_container" id="divsubject_arrow_left" >
                <div className="subject_arrow_text subject_arrow_text_left">
                  <label id="lblArrowLeftText"></label>
                </div>
                <div
                id="linkbtnArrowLeft" className="subject_arrow subject_arrow_left"></div>
              </div>
                <div className="subject_arrow_right_container" id="divsubject_arrow_right" >
                <div className="subject_arrow_text subject_arrow_text_right">
                  <label id="lblArrowRightText"></label>
                </div>
                <div id="linkbtnArrowRight" className="subject_arrow subject_arrow_right"></div>
              </div>
            </div> */}
          </div>
    </form>
  );
};
export default MyCompsCurrent;